import {
  useCallback,
  useState,
  type Dispatch,
  type SetStateAction,
} from "react";
import { formatDate2 } from "../../../utils/formatters";
import type {
  TablaAdminItem,
  TablaModalType,
  UseTablaReturn,
} from "./tablaTypes";

export const useTabla = (): UseTablaReturn => {
  const [activeModal, setActiveModal] = useState<TablaModalType | null>(null);
  const [selectedAdmin, setSelectedAdmin] = useState<TablaAdminItem | null>(
    null
  );

  const setModalState = useCallback(
    (modal: TablaModalType, value: SetStateAction<boolean>): void => {
      setActiveModal((currentModal) => {
        const isCurrentModalActive = currentModal === modal;
        const nextValue =
          typeof value === "function" ? value(isCurrentModalActive) : value;

        if (nextValue) {
          return modal;
        }

        return isCurrentModalActive ? null : currentModal;
      });
    },
    []
  );

  const setModalEdit: Dispatch<SetStateAction<boolean>> = useCallback(
    (value) => {
      setModalState("edit", value);
    },
    [setModalState]
  );

  const setModalDelete: Dispatch<SetStateAction<boolean>> = useCallback(
    (value) => {
      setModalState("delete", value);
    },
    [setModalState]
  );

  const setIsActualizarPago: Dispatch<SetStateAction<boolean>> = useCallback(
    (value) => {
      setModalState("actualizarPago", value);
    },
    [setModalState]
  );

  const openModal = useCallback((modal: TablaModalType, admin: TablaAdminItem) => {
    setSelectedAdmin(admin);
    setActiveModal(modal);
  }, []);

  const handleEditClick = useCallback(
    (admin: TablaAdminItem): void => {
      openModal("edit", admin);
    },
    [openModal]
  );

  const handleDeleteClick = useCallback(
    (admin: TablaAdminItem): void => {
      openModal("delete", admin);
    },
    [openModal]
  );

  const handleActualizarPago = useCallback(
    (admin: TablaAdminItem): void => {
      openModal("actualizarPago", admin);
    },
    [openModal]
  );

  const modalEdit = activeModal === "edit";
  const modalDelete = activeModal === "delete";
  const isActualizarPago = activeModal === "actualizarPago";

  return {
    formatDate2,
    isActualizarPago,
    modalDelete,
    modalEdit,
    selectedAdmin,
    handleActualizarPago,
    handleDeleteClick,
    handleEditClick,
    setIsActualizarPago,
    setModalDelete,
    setModalEdit,
  };
};
